import React, { useState, useEffect } from 'react';

const BlogFormModal = ({ isOpen, onClose, onSave, initialData }) => {
    const [formData, setFormData] = useState({
        title: '',
        author: '',
        tagline: '',
        content: ''
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');

    useEffect(() => {
        if (initialData) {
            setFormData({
                title: initialData.title || '',
                author: initialData.author || '',
                tagline: initialData.tagline || '',
                content: initialData.content || ''
            });
        } else {
            setFormData({
                title: '',
                author: '',
                tagline: '',
                content: ''
            });
        }
    }, [initialData, isOpen]);

    if (!isOpen) return null;

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        if (!formData.title || !formData.author || !formData.content) {
            setError('Please fill in title, author, and content');
            setLoading(false);
            return;
        }

        const result = await onSave(formData);
        if (!result.success) {
            setError(result.error);
        }
        setLoading(false);
    };

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" onClick={onClose}>
            <div className="bg-white rounded-xl max-w-3xl w-full max-h-[90vh] overflow-y-auto relative" onClick={(e) => e.stopPropagation()}>
                <button onClick={onClose} className="absolute right-4 top-4 text-gray-400 hover:text-gray-600 text-2xl z-10">
                    <i className="fas fa-times"></i>
                </button>

                <div className="p-6">
                    <h2 className="text-2xl font-bold text-gradpath-dark mb-4">
                        {initialData ? 'Edit Blog Post' : 'Create New Blog Post'}
                    </h2>

                    <form onSubmit={handleSubmit} className="space-y-4">
                        <input
                            type="text"
                            name="title"
                            placeholder="Article Title *"
                            value={formData.title}
                            onChange={handleChange}
                            className="w-full p-3 border border-gray-300 rounded-lg focus:border-gradpath-green outline-none"
                            required
                        />
                        
                        <input
                            type="text"
                            name="author"
                            placeholder="Author Name *"
                            value={formData.author}
                            onChange={handleChange}
                            className="w-full p-3 border border-gray-300 rounded-lg focus:border-gradpath-green outline-none"
                            required
                        />
                        
                        <textarea
                            name="tagline"
                            placeholder="Short Tagline/Excerpt (shown to all users)"
                            value={formData.tagline}
                            onChange={handleChange}
                            rows="2"
                            className="w-full p-3 border border-gray-300 rounded-lg focus:border-gradpath-green outline-none"
                        />
                        
                        <textarea
                            name="content"
                            placeholder="Full Article Content * (only visible to logged-in users)"
                            value={formData.content}
                            onChange={handleChange}
                            rows="10"
                            className="w-full p-3 border border-gray-300 rounded-lg focus:border-gradpath-green outline-none"
                            required
                        />

                        {error && (
                            <div className="p-3 bg-red-100 text-red-700 rounded-lg text-sm">
                                {error}
                            </div>
                        )}

                        <div className="flex gap-4 pt-4">
                            <button
                                type="button"
                                onClick={onClose}
                                className="flex-1 px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-all"
                            >
                                Cancel
                            </button>
                            <button
                                type="submit"
                                disabled={loading}
                                className="flex-1 bg-gradpath-green text-white px-4 py-2 rounded-lg hover:bg-gradpath-dark transition-all disabled:opacity-50"
                            >
                                {loading ? <i className="fas fa-spinner fa-spin"></i> : (initialData ? 'Update Post' : 'Publish Post')}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default BlogFormModal;